import React from 'react'
import * as Bootstrap from 'react-bootstrap'

const BotonTrash = ({onClick}) => {
    return (
        <Bootstrap.Form.Group
            as={Bootstrap.Col}
            style={{ marginBottom: 0, marginTop: 31 }}
        >
            <Bootstrap.Button
                onClick={onClick}
                variant="outline-primary"
            >
                <i className="fas fa-trash-alt"></i>
            </Bootstrap.Button>
        </Bootstrap.Form.Group>
    )
}

export default BotonTrash